import { render, staticRenderFns } from "./YearGraphTableAsPlany.vue?vue&type=template&id=149b845d&scoped=true&"
import script from "./YearGraphTableAsPlany.vue?vue&type=script&lang=js&"
export * from "./YearGraphTableAsPlany.vue?vue&type=script&lang=js&"
import style0 from "./YearGraphTableAsPlany.vue?vue&type=style&index=0&id=149b845d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b845d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VRadio,VRadioGroup})
